import { useFormikContext } from 'formik';
import { Text } from '@antimatterhq/ui/components/typography';
import Spacer from '@antimatterhq/ui/components/spacer';
import { Label } from '@antimatterhq/ui/components/label';
import { AddDetectionRuleSchemaValues } from '@/zod/schemas/detectionRules/AddDetectionRule';
import { FormMultiValues } from '@/components/form/multiValues/FormMultiValues';
import { FormTextarea } from '@/components/form/form';

export const NotableOutputSection = () => {
  const { values, handleChange, handleBlur, errors, touched } =
    useFormikContext<AddDetectionRuleSchemaValues>();

  return (
    <div>
      <Text size="xl" bold>
        Notable output
      </Text>
      <Spacer size="base" />
      <Label htmlFor="output.summary">Summary</Label>
      <FormTextarea
        id="output.summary"
        name="output.summary"
        value={values.output?.summary ?? undefined}
        onChange={handleChange}
        onBlur={handleBlur}
        aria-labelledby="output.summary-label"
      />
      {errors.output?.summary && touched.output?.summary && (
        <Text color="error">{errors.output?.summary}</Text>
      )}
      <Spacer size="lg" />
      <Text color="secondary">
        {`The notable summary is the title of the notable. It can contain SQL
        expressions in braces that will be substituted, e.g. “Password reset for
        {user_column}“. Notables with identical summaries will be deduplicated
        in some contexts`}
      </Text>

      <Spacer size="lg" />

      <Label htmlFor="output.context" id="output-context-label">
        Context
      </Label>
      <FormMultiValues
        name="output.context"
        onBlur={handleBlur}
        onChange={handleChange}
        values={values.output?.context}
        defaultValue={{ key: '', value: '' }}
        aria-labelledby="output-context-label"
      />
    </div>
  );
};
